export default {
  orders: [],
  pagination: {},
  order: {}
}
